import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useNavbarHelpers = () => {
  const router = useRouter()

  const isHome = useMemo(() => {
    return router.pathname === '/'
  }, [router.pathname])

  const isSexualHealth = useMemo(() => {
    return router.pathname === '/saude-sexual'
  }, [router.pathname])

  const isDermatology = useMemo(() => {
    return router.pathname === '/dermatologia'
  }, [router.pathname])

  const isWeight = useMemo(() => {
    return router.pathname === '/emagrecimento'
  }, [router.pathname])

  const isProducts = useMemo(() => {
    return router.pathname.includes('/produtos')
  }, [router.pathname])

  const isPsychology = useMemo(() => {
    return router.pathname === '/psicologia-sexual-parceria'
  }, [router.pathname])

  const isFaq = useMemo(() => {
    return router.pathname === '/faq'
  }, [router.pathname])

  return {
    isHome,
    isSexualHealth,
    isDermatology,
    isWeight,
    isProducts,
    isPsychology,
    isFaq
  }
}
